import {
    ChangeDetectionStrategy,
    Component,
    computed,
    input
} from '@angular/core';
import { RouterModule } from '@angular/router';
import {
    PlanBadgeMode,
    formatPlanId,
    planBadgeLabel
} from './plan-badge-label.util';

/**
 * Badge de plan (verde). Mismo aspecto en topbar, pay-ok y tarjetas de suscripción.
 * Con `routerLink` el host es navegable (topbar → cuenta).
 */
@Component({
    standalone: true,
    selector: 'app-plan-badge',
    imports: [RouterModule],
    templateUrl: './app-plan-badge.component.html',
    styleUrl: './app-plan-badge.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: {
        '[class.plan-badge--link]': 'isLink()',
        '[class.plan-badge--sm]': "size() === 'sm'",
        '[attr.aria-label]': 'ariaLabel() ?? displayLabel()'
    },
})
export class AppPlanBadgeComponent {
    readonly label = input<string | undefined>(undefined);

    readonly mode = input<PlanBadgeMode | undefined>(undefined);

    readonly planId = input<string | null | undefined>(undefined);

    readonly routerLink = input<string | string[] | undefined>(undefined);

    readonly ariaLabel = input<string | undefined>(undefined);

    readonly size = input<'sm' | 'md'>('md');

    readonly isLink = computed(() => {
        const link = this.routerLink();
        return link != null && link !== '';
    });

    readonly displayLabel = computed(() => {
        const explicit = this.label()?.trim();
        if (explicit) return explicit;

        const m = this.mode();
        if (m) return planBadgeLabel(m, this.planId());

        return formatPlanId(this.planId());
    });
}
